import $ from 'jquery';
import gsap from 'gsap';
import { fabric } from "fabric";


// Overlay Animation
var overlayDelete = gsap.timeline ({paused: true});
    overlayDelete.to('.overlay-poster',{
    autoAlpha: 0,
    delay: .3,
    duration: .5,
    ease:"power1.inOut",
    },0);

$('#overlayDelete').click(function () {
  overlayDelete.play();
});




//Setup Animation Image Add Gallery
var imageAddGallery = gsap.timeline ({paused: true, reversed: true});
    imageAddGallery.to('.image-dropdown-container',{
    display: "block",
    duration: 0,
    },0);
    imageAddGallery.from('.image-dropdown-container',{
      autoAlpha: 0,
      ease:"power1.inOut",
      delay: .2,
      duation: .2,
      },0);
    imageAddGallery.to('#add',{
      rotate: 45,
      ease:"power1.inOut",
      duration: .2,
      },0);

      $('#add').click(function () {
        imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
      });
  


/*
 * CANVAS SETTINGS STARTING HERE
 */

const canvas = document.getElementById('canvas');
const fabricCanvas = new fabric.Canvas(canvas);

// Bring active layers to front
function myDrag(e) {   // funciton on drag (moving)
  e.target.bringToFront();
}
fabricCanvas.on({
  'object:modified': myDrag,
});


// Image Add function with random placement

function addImage (url) {
  fabric.Image.fromURL(url, function (img) {
    var l = Math.random() * (300 - 0) + 0;
    var t = Math.random() * (500 - 0) + 0;                
    img.scale(0.3);
    img.set({'left':l});
    img.set({'top':t});
    fabricCanvas.add(img);
  },{
    cornerColor: 'black',
    borderColor: 'black',
  });
}

// Random Func
const randomFunc = [
  set1,
  set2,
  set3,
  set4,
  set5,
  set6,
  set7,
  set8,
  set9
]

// Adding Images here

randomFunc[Math.floor(Math.random() * randomFunc.length)]();
$('#reload').click( function () {
  randomFunc[Math.floor(Math.random() * randomFunc.length)]();
});
// $('#edit').click( function () {
//   fabricCanvas.clear();
//   addImage('/assets/images/projects/influenza/2.png');
//   addImage('/assets/images/projects/influenza/3.png');
// });
$('#delete').click( function () {
  fabricCanvas.remove(fabricCanvas.getActiveObject());
});

//PREDEFINED IMAGE SETS
function set1() {
  fabricCanvas.clear();
  addImage('/assets/images/projects/influenza/high/1/1.png');
  addImage('/assets/images/projects/influenza/high/1/2.png');
  addImage('/assets/images/projects/influenza/high/1/3.png');
}
function set2() {
  fabricCanvas.clear();
  addImage('/assets/images/projects/influenza/high/2/1.png');
  addImage('/assets/images/projects/influenza/high/2/2.png');
}
function set3() {
  fabricCanvas.clear();
  addImage('/assets/images/projects/influenza/high/3/1.png');
  addImage('/assets/images/projects/influenza/high/3/2.png');
  addImage('/assets/images/projects/influenza/high/3/3.png');
}
function set4() {
  fabricCanvas.clear();
  addImage('/assets/images/projects/influenza/high/4/1.png');
  addImage('/assets/images/projects/influenza/high/4/2.png');
}
function set5() {
  fabricCanvas.clear();
  addImage('/assets/images/projects/influenza/high/5/1.png');
}
function set6() {
  fabricCanvas.clear();
  addImage('/assets/images/projects/influenza/high/6/1.png');
  addImage('/assets/images/projects/influenza/high/6/2.png');
  addImage('/assets/images/projects/influenza/high/6/3.png');
}
function set7() {
  fabricCanvas.clear();
  addImage('/assets/images/projects/influenza/high/7/1.png');
}
function set8() {
  fabricCanvas.clear();
  addImage('/assets/images/projects/influenza/high/8/1.png');
  addImage('/assets/images/projects/influenza/high/8/2.png');
  addImage('/assets/images/projects/influenza/high/8/3.png');
}
function set9() {
  fabricCanvas.clear();
  addImage('/assets/images/projects/influenza/high/9/1.png');
  addImage('/assets/images/projects/influenza/high/9/2.png');
  addImage('/assets/images/projects/influenza/high/9/3.png');
}


// Add Single Images
$('#addSingle11').click( function () {
  addImage('/assets/images/projects/influenza/high/1/1.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})
$('#addSingle12').click( function () {
  addImage('/assets/images/projects/influenza/high/1/2.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})
$('#addSingle13').click( function () {
  addImage('/assets/images/projects/influenza/high/1/3.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})

$('#addSingle21').click( function () {
  addImage('/assets/images/projects/influenza/high/2/1.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})
$('#addSingle22').click( function () {
  addImage('/assets/images/projects/influenza/high/2/2.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})

$('#addSingle31').click( function () {
  addImage('/assets/images/projects/influenza/high/3/1.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})
$('#addSingle32').click( function () {
  addImage('/assets/images/projects/influenza/high/3/2.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})
$('#addSingle33').click( function () {
  addImage('/assets/images/projects/influenza/high/3/3.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})

$('#addSingle41').click( function () {
  addImage('/assets/images/projects/influenza/high/4/1.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})
$('#addSingle42').click( function () {
  addImage('/assets/images/projects/influenza/high/4/2.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})

$('#addSingle51').click( function () {
  addImage('/assets/images/projects/influenza/high/5/1.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})

$('#addSingle61').click( function () {
  addImage('/assets/images/projects/influenza/high/6/1.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})
$('#addSingle62').click( function () {
  addImage('/assets/images/projects/influenza/high/6/2.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})
$('#addSingle63').click( function () {
  addImage('/assets/images/projects/influenza/high/6/3.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})

$('#addSingle71').click( function () {
  addImage('/assets/images/projects/influenza/high/7/1.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})

$('#addSingle81').click( function () {
  addImage('/assets/images/projects/influenza/high/8/1.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})
$('#addSingle82').click( function () {
  addImage('/assets/images/projects/influenza/high/8/2.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})
$('#addSingle83').click( function () {
  addImage('/assets/images/projects/influenza/high/8/3.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})

$('#addSingle91').click( function () {
  addImage('/assets/images/projects/influenza/high/9/1.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})
$('#addSingle92').click( function () {
  addImage('/assets/images/projects/influenza/high/9/2.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})
$('#addSingle93').click( function () {
  addImage('/assets/images/projects/influenza/high/9/3.png');
  imageAddGallery.reversed() ? imageAddGallery.timeScale(1.0).play() : imageAddGallery.timeScale(1.0).reverse();
})


// fabric.Image.fromURL('/assets/images/projects/influenza/1.png', function(img) {
//     var oImg = img.set({ left: 0, top: 0}).scale(1);
//     fabricCanvas.add(oImg);
// });

// canvasParent is the parent element of the canvas.
// We'll monitor changes in its width through a ResizeObserver.
// When the width of canvasParent changes, we change the width (and height)
// of the fabric canvas as well.
const canvasParent = canvas.parentElement;

// Start a resize observer on the parent of the canvas
new ResizeObserver(() => {

	const fabricWidth = fabricCanvas.getWidth();
  const fabricHeight = fabricCanvas.getHeight();
  const cssWidth = Math.min(canvasParent.clientWidth, fabricWidth);
  const ratio = fabricWidth / canvasParent.clientWidth;

	fabric.Object.prototype.set({
  	cornerSize: ratio * 10,
    borderScaleFactor: ratio
  });
  
  fabric.Object.prototype.controls.mtr.offsetY = -25 * ratio;

  fabricCanvas.setDimensions(
		{
			width: cssWidth + 'px', 
			height: cssWidth / (fabricWidth/fabricHeight) + 'px'
		},
		{ cssOnly: true }
  )
  .requestRenderAll();
  
}).observe(canvasParent);

// Save Image Function **

let saveBtn = document.getElementById('save')
saveBtn.addEventListener('click', function(){
    let data = canvas.toDataURL({multiplier: 3000 / canvas.height}) //Resize to 3000px
    let link = document.createElement('a')
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    link.href = data;
    link.download = "flu_poster" + '-' + mm + '-' + dd + '-' + yyyy + '.jpg'
    link.click();
})